import React, { useContext, CSSProperties, ComponentProps } from 'react'
import { Box } from '../../new/core-components/box'
import { popperContext } from './Popover'

type Props = ComponentProps<typeof Box> & {
  style?: CSSProperties
}

/** @deprecated Use trigger prop on Popover from @chilipiper/design-system/src/new instead */
export const PopoverTrigger = ({ children, ...others }: Props) => {
  const { setTriggerElem } = useContext(popperContext)

  return (
    <Box w='auto' display='inline-block' {...others} ref={setTriggerElem}>
      {children}
    </Box>
  )
}
